import { ArtifactProto } from "build-ts/chat_session";
import showToast from "hooks/useCustomToast";


export const populateArtifact = async (request: ArtifactProto) => {
	try {
		const response = await fetch(process.env.REACT_APP_POPULATE_ARTIFACT!, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(ArtifactProto.toJSON(request)),
			credentials: "include",
		});
		if (!response.ok) {
			showToast("Error populating artifact", "", "error");
			return null;
		}

		const responseData = await response.json();
		return ArtifactProto.fromJSON(responseData);
	} catch (error) {
		showToast("Error populating artifact", "", "error");
		return null;
	}
};
